import React, { useState } from 'react';
import { GeckoIcon } from 'ui';
import Dropdown from 'react-bootstrap/Dropdown';
import './index.scss';

export const OptionalRequiredFieldsDropdown = (props) => {
  const {
    fieldName,
    updateRequiredStatus,
    isRequired,
    canRemoveField = false,
    removeField,
  } = props;
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const renderRemoveField = () =>
    canRemoveField ? (
      <>
        <Dropdown.Divider />
        <Dropdown.Item
          as="button"
          className="OptionalRequiredFieldsDropdown_item gecko-dropdown-item-delete"
          onClick={removeField}
        >
          <i className="far fa-trash-alt" />
          Remove Field
        </Dropdown.Item>
      </>
    ) : undefined;

  const renderOptionButtons = () => (
    <>
      <div
        onClick={() => updateRequiredStatus(true)}
        className="OptionalRequiredFieldsDropdown_item radio-button"
      >
        <input
          type="radio"
          name={`isRequired-${fieldName}`}
          checked={isRequired}
          onChange={() => {}}
        />{' '}
        Required
      </div>
      <div
        onClick={() => updateRequiredStatus(false)}
        className="OptionalRequiredFieldsDropdown_item  radio-button"
      >
        <input
          type="radio"
          name={`isRequired-${fieldName}`}
          onChange={() => {}}
          checked={!isRequired}
        />{' '}
        Optional
      </div>
    </>
  );

  return (
    <div className="OptionalRequiredFieldsDropdown">
      <Dropdown
        show={dropdownOpen}
        onToggle={() => setDropdownOpen(!dropdownOpen)}
      >
        <Dropdown.Toggle
          variant="secondary"
          className="gecko-btn gecko-ui-material btn btn-default"
          size="sm"
        >
          {fieldName}{' '}
          {dropdownOpen ? (
            <GeckoIcon icon="far fa-angle-up" />
          ) : (
            <GeckoIcon icon="far fa-angle-down" />
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu className="OptionalRequiredFieldsDropdown_menu gecko-dropdown-menu">
          <div className="dropdown-item">
            {renderOptionButtons()}
            {renderRemoveField()}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default OptionalRequiredFieldsDropdown;
